import api from '../../services/api';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';

export const fetchDistributionLists = async () => {
  const response = await api.get(`/distributionLists`);

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.distribution-lists') }));
  }

  return response.data;
};

export const fetchDistributionListById = async (id: number | string | undefined | null) => {
  const response = await api.get(`/distributionLists/${id}`);
  if (!response) {
    toast.error(i18n.t('error.api.get-item', { item: i18n.t('module.distribution-list') }));
  }
  return response.data;
};

export const createDistributionList = async (data: unknown) => {
  const response = await api.post(`/distributionLists`, data);

  if (!response) {
    toast.error(i18n.t('error.api.post-item', { item: i18n.t('module.distribution-list') }));
  }
  return response.data;
};

export const updateDistributionList = async ({ data }: { data: unknown }) => {
  const response = await api.put(`/distributionLists`, data);

  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.distribution-list') }));
  }

  return true;
};

export const deleteDistributionList = async (params: { ids: number[] }) => {
  const response = await api.delete(`/distributionLists`, { data: params });
  if (!response) {
    toast.error(i18n.t('error.api.delete-item', { item: i18n.t('module.distribution-list') }));
  }
  return true;
};
